import React, {useState, useEffect, useRef} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import performanceService from '../../services/data/performance.service'
import { Toast } from 'primereact/toast';
import { useFormik } from 'formik';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import companyService from '../../services/data/company.service'
import employeeService from '../../services/data/employee.service';
import SkeletonProcess from '../../pages/performance/skeletonProcess';
import { Avatar } from 'primereact/avatar';
import NameInitials from '../../helpers/nameInitials';


export default function ParticipantsSelect(props) {

    const [pageLoad, setPageLoad] = useState(true)
    const [filterLoad, setFilterLoad] = useState(false)
    const toast = useRef(null);
    const [itemsList, setItemsList] = useState([]);
    const [page, setPage] = useState(1)
    const [clear, setClear] = useState(false)

    const [subCompaniesList, setSubCompaniesList] = useState([]) // lista de subCompanies
    const [subcompany, setSubcompany] = useState('')

    const [deptosList, setDeptosList] = useState([]) // lista de departamentos
    const [deptos, setDeptos] = useState([])

    const [selected, setSelected] = useState([])
    const [confirmLoading, setConfirmLoading] = useState(false)


    useEffect(() => {
        listItems()
    }, [page])

    useEffect(() => {
        listSubCompanies()
        listDeptos()
    }, [])

    function listItems() {
        let data = {
            company_id: localStorage.getItem("companyId"),
        }

        employeeService.listManagers(page, data).then((response) => {
            if (response.count > 0){
                setItemsList(response)
            } else {
                toast.current.show({ severity: 'warn', summary: 'Ops', detail: "Nenhum item encontrado", life: 4000 });
            }
        }).catch((error) => {
            toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 4000 });
        }).finally(() => {
            setPageLoad(false)
        })
    }

    function listSubCompanies() {

        const getItem = ''

        companyService.autoCompleteSubCompany(getItem).then((response) => {
        
            let res = response.map((item) => {
                return {
                    title: item.title,
                    value: item.id
                }
            })
            setSubCompaniesList(res)

        })
        .catch((error) => {
            console.log(error.response.data)
        });

    }

    function listDeptos() {
        companyService.listDepartmentSimple().then((response) => {

            let res = response.map((item) => {
                return {
                    title: item.title,
                    value: item.id
                }
            })
            setDeptosList(res)
        }).catch((error) => {
            console.log(error.response)
        });
    }

    function addPage() {
        setPage(page + 1)
    }

    function subPage() {
        setPage(page - 1)
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: '',
        },
        onSubmit: values => {

            setFilterLoad(true)
            setClear(true)

            let data = {
                company_id: localStorage.getItem("companyId"),
                user: values.title,
            }

            if (subcompany) {
                data.jobposition__subcompany = subcompany
            }
            
            if (deptos.length > 0) {
                data.jobposition__department = deptos
            }
            
            employeeService.listManagers(1, data).then((response) => {
                if (response.count > 0){
                    setItemsList(response)
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Ops', detail: "Nenhum item encontrado", life: 4000 });
                }
            }).catch((error) => {
                toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 4000 })
            }).finally(() => {
                setFilterLoad(false)
            })

        }
    })

    function clearItems() {
        formik.resetForm();
        setSubcompany('')
        setDeptos([])
    }

    function checkItem(e) {
        const val = String(e.target.value)
        const isChecked = e.target.checked

        const row = itemsList?.results?.find((r) => String(r.id) === val)
        const childrenList = row?.children?.map((ch) => String(ch.id)) || []

        if (isChecked) {
            const data = { manager: val, children: [...childrenList] }
            setSelected((prev) => {
                if (prev.some((x) => String(x.manager) === val)) return prev
                return [...prev, data]
            })
        } else {
            setSelected((prev) => prev.filter((x) => String(x.manager) !== val))
        }
    }

    function removeItem(manager_id, emp_id, isChecked) {
        const m = String(manager_id)
        const emp = String(emp_id)

        setSelected((prev) => {
            const sl = prev.findIndex((e) => String(e.manager) === m)
            if (sl === -1) return prev
            const newArray = prev.map((e) => ({
                ...e,
                children: [...e.children],
            }))
            const entry = newArray[sl]

            if (entry.children.length === 1) {
                newArray.splice(sl, 1)
                return newArray
            }

            if (!isChecked) {
                entry.children = entry.children.filter((id) => String(id) !== emp)
                return newArray
            }

            if (!entry.children.some((id) => String(id) === emp)) {
                entry.children.push(emp)
            }
            return newArray
        })
    }

    function checifInList(id) {
        const sid = String(id)
        return selected.some((item) => String(item.manager) === sid)
    }

    function checifInChildren(manager_id, emp_id) {
        const m = String(manager_id)
        const eid = String(emp_id)
        const entry = selected.find((x) => String(x.manager) === m)
        if (!entry) return false
        return entry.children.some((cid) => String(cid) === eid)
    }

    function checkAll(e) {
        const on = e.target.checked

        if (!on) {
            setSelected([])
            return
        }

        if (itemsList?.results?.length > 0) {
            const results = itemsList.results.map((item) => ({
                manager: String(item.id),
                children: (item.children || []).map((ch) => String(ch.id)),
            }))
            setSelected(results)
        }
    }

    async function confirmParticipants() {
        setConfirmLoading(true)
        try {
            const data = {
                company_id: localStorage.getItem("companyId"),
                participants: selected,
                id: props.id,
            }

            const response = await performanceService.addParticipantsPerformanceTemplate(data)

            if (props.assessmentType === 'TD') {
                const peerCalls = []
                for (const group of selected) {
                    if (group.children.length < 2) continue
                    const review = response.participants?.find((r) =>
                        r.managers?.some((m) => String(m.id) === String(group.manager))
                    )
                    if (!review) continue
                    for (let i = 0; i < group.children.length; i++) {
                        for (let j = 0; j < group.children.length; j++) {
                            if (i !== j) {
                                peerCalls.push(
                                    performanceService.addPeerStep({
                                        review_id: review.id,
                                        peer_id: group.children[i],
                                        employee_id: group.children[j],
                                    })
                                )
                            }
                        }
                    }
                }
                if (peerCalls.length > 0) {
                    await Promise.all(peerCalls)
                }
            }

            props.setObject(response)
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Participantes adicionados com sucesso', life: 3000 })
            setTimeout(() => { props.hideModal() }, 3000)
        } catch (error) {
            toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error.response?.data || error.message), life: 4000 })
        } finally {
            setConfirmLoading(false)
        }
    }

    return (
        <div className='row'>
            <Toast ref={toast} position="top-right" />
            <div className='col-3'>
                <p className='fw-bold mt-3'>Filtros</p>
                <form onSubmit={formik.handleSubmit} className='bg-light p-3 rounded'>
                    <div className="col mb-3">
                        <label className="form-label">Nome</label>
                        <input name='title' type="text" className="form-control" {...formik.getFieldProps('title')} />
                    </div>
                    <div className="col mb-3">
                        <label className="form-label">Organização</label>
                        <div className='p-inputgroup'>
                            <Dropdown filter placeholder="Selecionar" value={subcompany} optionLabel="title" options={subCompaniesList} onChange={(e) => {setSubcompany(e.value); formik.setFieldValue('subcompany', e.value);} } className="rounded" />
                        </div>
                    </div>
                    <div className="col mb-3">
                        <label className="form-label">Departamento</label>
                        {
                            deptos.length > 0 ?
                            <span className='ms-1 fw-bold'>({deptos.length})</span>
                            : null
                        }
                        <div className='p-inputgroup'>
                            <MultiSelect filter optionLabel='title' optionValue='value' placeholder="Selecionar" value={deptos} onChange={(e) => {setDeptos(e.value);}} options={deptosList} display="chip" className="rounded" />
                        </div>
                    </div>
                    <div className="btnMargin">
                        <button className="btn btn-success btn-sm btn-rounded px-4" type="submit">
                            Filtrar
                        </button>
                        {
                            clear ?
                            <span role='button' className='fw-bold float-end mt-2' onClick={() => {clearItems(); listItems()}}>Limpar</span>
                            :null
                        }
                        
                    </div>
                </form>
            </div>
            <div className='col-9'>
                {
                    filterLoad || pageLoad ?
                    <SkeletonProcess />
                    :
                    <>
                    {
                        selected.length > 0?
                        <>
                        <div className='alert alert-warning'>
                            <label className='fw-bold pe-3'>{selected.length} Selecionados</label>
                            <button 
                                className='btn btn-sm btn-rounded btn-success px-3' 
                                onClick={() => confirmParticipants()}
                                disabled={confirmLoading}
                            >
                                {confirmLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Confirmando...
                                    </>
                                ) : (
                                    'Confirmar'
                                )}
                            </button>
                        </div>
                        </>
                        : null
                    }
                    {
                        itemsList && itemsList.results && itemsList.results.length > 0 ?
                        <>
                        <table className='table text-default borderBottom mt-3'>
                            <thead className='borderBottom'>
                                <tr>
                                    <th colSpan='3'>
                                        Gestor
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="p-3 bg-light border-start border-end">
                                    <td colSpan="3">
                                        <div className="input-group">
                                            <div className="input-group-text bg-transparent border-0">
                                                <input className='form-check-input mt-0' type="checkbox" onChange={checkAll} />
                                            </div>
                                            <label className='form-check-label pt-1'>Selecionar Todos</label>
                                        </div>
                                        
                                    </td>
                                </tr>
                            {
                                itemsList.results.map((item) =>
                                <React.Fragment key={item.id}>
                                    <tr key={item.id} className='border-top border-end'>
                                        <td className="border-start border-end" width='10px' rowSpan='2'>
                                            <div className="input-group">
                                                <div className="input-group-text bg-transparent border-0">
                                                    <input id={`manager-choice-${item.id}`} name='managerChoices' checked={checifInList(item.id)} type="checkbox" className="form-check-input mt-0" value={item.id} onChange={checkItem} />
                                                </div>                                     
                                            </div>
                                        </td>
                                        <td className="align-middle" width='20px'>
                                            <span>
                                            {
                                                item.user.photo ?
                                                <Avatar title={item.user.full_name} image={item.user.photo} style={{ backgroundColor: '#42c0fb', color: '#ffffff', fontWeight: 'bold' }} shape='circle' />
                                                :
                                                <Avatar title={item.user.full_name} label={NameInitials( item.user.full_name )} style={{ backgroundColor: '#42c0fb', color: '#ffffff', fontWeight: 'bold' }} shape='circle'/>
                                            }
                                            </span>
                                        </td>
                                        <td className="align-middle">
                                            <span className='fw-bold text-decoration-none'>
                                                {item.user.full_name}
                                            </span>
                                        </td>
                                    </tr>
                                    {
                                        item.children.length > 0 ?
                                        <tr className='border-top border-end'>
                                            <td colSpan='3'>
                                                <table className='table table-borderless'>
                                                    <tbody>
                                                    {
                                                        item.children.map((emp) => 
                                                        <tr key={emp.id}>
                                                            <td className="align-middle" width='10px'>
                                                                <div className="input-group">
                                                                    <div className="input-group-text bg-transparent border-0">
                                                                        <input checked={checifInChildren(item.id, emp.id)} onChange={(e) => removeItem(item.id, emp.id, e.target.checked)} id={`child-${item.id}-${emp.id}`} name={`child_${item.id}`} type="checkbox" className="form-check-input mt-0" value={emp.id} />
                                                                    </div>                                     
                                                                </div>
                                                            </td>
                                                            <td className="align-middle" width='20px'>
                                                                {
                                                                    emp.user.photo ?
                                                                    <Avatar title={emp.user.full_name} image={emp.user.photo} style={{ backgroundColor: '#42c0fb', color: '#ffffff', fontWeight: 'bold' }} shape='circle' />
                                                                    :
                                                                    <Avatar title={emp.user.full_name} label={NameInitials( emp.user.full_name )} style={{ backgroundColor: '#42c0fb', color: '#ffffff', fontWeight: 'bold' }} shape='circle'/>
                                                                }
                                                            </td>
                                                            <td className="align-middle">
                                                                <span className='fw-bold text-decoration-none'>
                                                                    {emp.user.full_name}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        )
                                                    }
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        : null
                                    }
                                    </React.Fragment>
                                )
                            }
                            </tbody>
                        </table>
                        <div className='float-end'>
                            <nav>
                                <ul className='pagination pagination-sm'>
                                    <li className='page-item'>
                                        { 
                                            itemsList.previous ? 
                                            <span onClick={subPage} className='page-link text-default'>
                                                <FontAwesomeIcon className='' icon={solid('angle-left')} />
                                            </span>
                                            :
                                            <span className='page-link text-grey disabled'>
                                                <FontAwesomeIcon className='' icon={solid('angle-left')} />
                                            </span>
                                        }
                                    </li>
                                    <li className='page-item'>
                                        {
                                            itemsList.next ?
                                            <span onClick={addPage} className='page-link text-default'>
                                                <FontAwesomeIcon className='' icon={solid('angle-right')} />
                                            </span>
                                            :
                                            <span className='page-link text-grey disabled'>
                                                <FontAwesomeIcon className='' icon={solid('angle-right')} />
                                            </span>
                                        }
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        </>

                        :
                        <>
                        Nenhum item criado ainda
                        </>
                    }
                    </>
                }
            </div>
        </div>
    )
}